export enum U21AiChatBubbleType {
  BUTTON = 'button',
  MULTISELECT = 'multiselect',
  SINGLESELECT = 'singleselect',
}

export const MAX_AI_CHAT_CHOICES = 5;

export interface U21AiChatBubbleInnerProps {
  choices: string[];
  disabled?: boolean;
}

export interface U21AiChatButtonInnerProps extends U21AiChatBubbleInnerProps {
  onSubmit: (answer: string) => void;
}

export interface U21AiChatMultiSelectInnerProps extends U21AiChatBubbleInnerProps {
  initialValues?: string[];
  onSubmit: (answer: string[]) => void;
}

export interface U21AiChatSingleSelectInnerProps extends U21AiChatBubbleInnerProps {
  initialValues?: string;
  onSubmit: (answer: string) => void;
}

export type U21AiChatRenderInnerProps = U21AiChatBubbleInnerProps &
  (
    | {
        type: U21AiChatBubbleType.BUTTON;
        values: string;
        onSubmit: (answer: string) => void;
      }
    | {
        type: U21AiChatBubbleType.MULTISELECT;
        values: string[];
        onSubmit: (answer: string[]) => void;
      }
    | {
        type: U21AiChatBubbleType.SINGLESELECT;
        values: string;
        onSubmit: (answer: string) => void;
      }
  );
